import { render } from "./MedNyttSearchPage.vue?vue&type=template&id=3f52f68b&scoped=true"
import script from "./MedNyttSearchPage.vue?vue&type=script&lang=js"
export * from "./MedNyttSearchPage.vue?vue&type=script&lang=js"

import "./MedNyttSearchPage.vue?vue&type=style&index=0&id=3f52f68b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f52f68b"]])

export default __exports__